export default __webpack_public_path__ + "static/media/Pickpocket's Armbands of the Deceiver.b2a1919d.jpg";